import { actionTypes } from './actions';

const initialState = {
  showSearch: false,
};

export default function searchModalReducer(state = initialState, action) {
  switch (action.type) {
    case actionTypes.HANDLER_SEARCH_OVERLAY:
      return { showSearch: !state.showSearch };
    default:
      return state;
  }
}
